import React from "react";

export type BadgeVariant = "success" | "info" | "warn" | "danger" | "neutral";

interface BadgeProps {
  variant?: BadgeVariant;
  dot?: boolean;
  className?: string;
  style?: React.CSSProperties;
  /** Tooltip — für Badges, deren Text abgeschnitten wird (truncate). */
  title?: string;
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = "neutral",
  dot = false,
  className = "",
  style,
  title,
  children,
}) => (
  <span className={`ds-badge ds-badge-${variant} ${className}`} style={style} title={title}>
    {dot && <span className="ds-bdot" />}
    {children}
  </span>
);
